import { usePlaySound, btnDelay } from "common/utils";
import i18n from "features/parent/i18n";
import { FeedbackHistoryItem } from "features/parent/types";
import { FeedbackSummaryCard } from "./FeedbackSummaryCard";

interface FeedbackHistorySectionProps {
  feedbackItems: FeedbackHistoryItem[];
  onShowMore: () => void;
  onSelectItem: (item: FeedbackHistoryItem) => void;
}

export const FeedbackHistorySection = ({
  feedbackItems,
  onShowMore,
  onSelectItem,
}: FeedbackHistorySectionProps) => {
  const play = usePlaySound();

  const handleShowMore = () => {
    play();
    btnDelay(() => onShowMore());
  };

  const handleSelectItem = (item: FeedbackHistoryItem) => {
    play();
    btnDelay(() => onSelectItem(item));
  };

  return (
    <div className="bg-white rounded-[16px] p-6">
      {/* ヘッダー */}
      <div className="flex-row-el items-center justify-between mb-5 pb-3 border-b border-outline">
        <div className="flex-row-el items-center gap-2 text-[24px] text-textcolor-black">
          <span className="material-symbols-outlined !text-[45px] text-red-100">forum</span>
          {i18n.t("MSG_PARENT_PAGE_FEEDBACK_HISTORY")}
          <span className="text-[21px] font-normal text-gray2-100 ml-1">
            ({feedbackItems.length})
          </span>
        </div>

        {/* もっと見るボタン（4件以上の場合） */}
        {feedbackItems.length > 3 && (
          <button
            className="flex-row-el items-center gap-1 px-4 py-2 bg-transparent border-2 border-red-100 rounded-[12px] text-[21px] text-red-100 cursor-pointer hover:bg-red-100/10 transition-all"
            onClick={handleShowMore}
          >
            {i18n.t("MSG_PARENT_PAGE_PLAYER_SHOW_MORE")}
            <span className="material-symbols-outlined text-[24px]">chevron_right</span>
          </button>
        )}
      </div>

      {/* サマリーカード表示（最大3件、スクロールなし） */}
      {feedbackItems.length > 0 ? (
        <div className="flex-col-el gap-3">
          {feedbackItems.slice(0, 3).map((item) => (
            <FeedbackSummaryCard key={item.id} item={item} onClick={() => handleSelectItem(item)} />
          ))}
        </div>
      ) : (
        <div className="flex-col-center py-8 text-gray2-100">
          <span className="material-symbols-outlined text-[60px] mb-2">forum</span>
          <span className="text-[21px]">{i18n.t("MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY")}</span>
        </div>
      )}
    </div>
  );
};
